import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { MessageModule } from 'primeng/message';
import { ToastModule } from 'primeng/toast';

@Component({
    selector: 'message',
    imports: [MessageModule, ToastModule, TranslateModule],
    templateUrl: './message.component.html',
    styleUrl: './message.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class MessageComponent {
    id = input.required<string>();

    text = input<string[] | null>(null);
    severity = input<'warn' | 'error' | 'info' | 'success' | 'secondary'>('warn');
    closable = input<boolean>(false);
    icon = input<string>('');
    enableService = input<boolean>(true);
}
